"use client";

export default function IosInstallModal({
    logoSrc = "/assets/about.jpg",
    title = " قصه شب داستان و کتاب صوتی کودک",
    onClose,
}) {
    return (
        <div
            className="fixed inset-0 z-[9999] bg-white flex flex-col items-center justify-between px-6 py-8 text-center"
            dir="rtl"
        >
            <div className="w-full flex flex-col items-center pt-14">
                <img
                    src={logoSrc}
                    alt={title}
                    className="w-28 h-28 object-contain mb-8 rounded-full md:max-w-[20rem]"
                />

                <p className="text-gray-600 leading-8 text-base mb-10 max-w-sm">
                    وب اپلیکیشن <strong>قصه شب</strong> را به صفحه اصلی موبایل خود اضافه کنید.
                </p>

                <div className="w-full max-w-sm space-y-5">
                    <div className="flex items-center justify-start gap-3">
                        <div className="w-11 h-11 shrink-0 rounded-full bg-blue-50 flex items-center justify-center">
                           <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                            className="w-6 h-6 text-blue-500"
                        >
                            <path d="M8 12H3v9h18v-9h-5" />
                            <polyline points="12 3 12 15" />
                            <polyline points="8 7 12 3 16 7" />
                        </svg>
                        </div>

                        <div className="text-right">
                            <p className="font-bold text-[#0b4a6f] text-base">Share</p>
                            <p className="text-gray-600 text-xs leading-6 mt-1">
                                از نوار پایین روی گزینه اشتراک‌گذاری بزنید
                            </p>
                        </div>
                    </div>

                    <div className="flex items-center justify-start gap-3">
                        <div className="w-11 h-11 shrink-0 rounded-full bg-blue-50 flex items-center justify-center">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                aria-hidden="true"
                                className="w-6 h-6 text-blue-500"
                            >
                                <rect x="3" y="3" width="18" height="18" rx="3" />
                                <line x1="12" y1="8" x2="12" y2="16" />
                                <line x1="8" y1="12" x2="16" y2="12" />
                            </svg>
                        </div>

                        <div className="text-right">
                            <p className="font-bold text-[#0b4a6f] text-base">
                                Add to Home Screen
                            </p>
                            <p className="text-gray-600 text-xs leading-6 mt-1">
                                این گزینه را از منوی باز شده انتخاب کنید
                            </p>
                        </div>
                    </div>

                    <div className="flex items-center justify-start gap-3">
                        <div className="w-11 h-11 shrink-0 rounded-full bg-green-50 flex items-center justify-center">
                            <img
                                src={logoSrc}
                                alt={title}
                                className="w-11 h-11 shrink-0 rounded-full"
                            />

                        </div>

                        <div className="text-right">
                            <p className="font-bold text-[#0b4a6f] text-base">Add</p>
                            <p className="text-gray-600 text-xs leading-6 mt-1">
                                در نهایت روی گزینه Add بزنید
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <button
                type="button"
                onClick={onClose}
                className="w-full max-w-sm bg-green-500 hover:bg-green-600 transition text-white rounded-lg py-2 text-md"
            >
                متوجه شدم!
            </button>
        </div>
    );
}
